import { Component, inject, Input, OnInit } from '@angular/core'
import { PaymentPlan } from '@client/PaymentPlan'
import { Table } from '@ui/Table'
import { Router } from '@angular/router'
import Order, { STATUS_CANCELLED } from '@client/Order'
import { SystemConfigService } from '@client/Services/SystemConfigService'
import { CdkTableComponent } from '@ui/Components/Table/CdkTable.Component'
import { RaisedButtonComponent } from '@ui/Components/Form/Button/RaisedButton.Component'

@Component({
	selector: 'order-payment-plans',
	templateUrl: './OrderPaymentPlans.Component.html',
	imports: [CdkTableComponent, RaisedButtonComponent],
})
export class OrderPaymentPlansComponent
	extends Table<PaymentPlan>
	implements OnInit
{
	@Input() protected readonly order: Order

	protected disableSetup: boolean = false

	private readonly router: Router

	private readonly systemConfigService: SystemConfigService

	constructor() {
		super()
		this.router = inject(Router)
		this.systemConfigService = inject(SystemConfigService)
	}

	public ngOnInit() {
		this.displayColumns = ['id', 'total']

		this.disableSetup = this.order.status === STATUS_CANCELLED

		this.tableEntities = [
			{
				columnDef: 'id',
				header: 'ID',
				accessorKey: 'service_id',
			},
			{
				columnDef: 'total',
				header: 'Total Amount',
				accessorKey: 'total_amount',
				type: 'currency',
				currency: {
					currency: this.order.currency,
					currencyPrecision: this.order.currency_precision,
					locale: this.systemConfigService.config.locale,
				},
			},
		]

		this.setTableData(this.order.payment_plans)
	}

	protected readonly setup = async () => {
		if (this.disableSetup) {
			return
		}

		await this.router.navigateByUrl(
			`/my-account/orders/${this.order.id}/payment-plans/setup`,
		)
	}

	protected readonly navigatePlan = async (
		entity: PaymentPlan,
	): Promise<void> => {
		await this.router.navigateByUrl(
			`/my-account/orders/${this.order.id}/payment-plans/${entity.id}`,
		)
	}
}
